import type { Database } from '@areapif/areapif-shared'
import { createClient } from '@supabase/supabase-js'

const supabaseUrl: unknown = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey: unknown = import.meta.env.VITE_SUPABASE_ANON_KEY

if (typeof supabaseUrl !== 'string' || !supabaseUrl) {
  throw new Error('Missing VITE_SUPABASE_URL environment variable')
}

if (typeof supabaseAnonKey !== 'string' || !supabaseAnonKey) {
  throw new Error('Missing VITE_SUPABASE_ANON_KEY environment variable')
}

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storageKey: 'supabase.auth.token',
  },
})

/**
 * Generate public URL for inspection images (photos/seals)
 * Replicates mobile app's getRemoteUrl function
 * @param bucket - Storage bucket name (always 'inspections')
 * @param key - Storage path/key (the photo/seal ID from database)
 * @returns Public URL for the image
 */
export const getRemoteUrl = (bucket: string, key: string): string => {
  const {
    data: { publicUrl },
  } = supabase.storage.from(bucket).getPublicUrl(key)
  return publicUrl
}
